import { isDateValidAndPast } from 'src/components/oneCorp/features/MealCredit/utils/isDateValidAndPast';

interface OneTimeUseCaseProps {
  isDailyLengthBudget: boolean;
  formattedStartCycleDate: string;
  formattedEndCycleDate: string;
  isRepeating: boolean;
  isMealCreditAvailable: boolean;
  expirationDate: Date;
}

const getLinkWord = (
  isRepeating: boolean,
  isDailyLengthBudget: boolean
): string => {
  if (isRepeating && isDailyLengthBudget) {
    return 'on';
  }
  if (!isDailyLengthBudget) {
    return 'from';
  }
  if (!isRepeating && isDailyLengthBudget) {
    return 'for';
  }

  return '';
};

export function getCurrentCycleText(props: OneTimeUseCaseProps): string {
  const {
    isDailyLengthBudget,
    formattedStartCycleDate,
    formattedEndCycleDate,
    isRepeating,
    isMealCreditAvailable,
    expirationDate,
  } = props;

  const unavailableText = !isMealCreditAvailable ? ' unavailable' : '';
  const oneTimeCurrentCycleText = isRepeating
    ? 'Current cycle'
    : 'One-time credit';
  const linkWord = getLinkWord(isRepeating, isDailyLengthBudget);

  if (isRepeating && isDateValidAndPast(expirationDate)) {
    return `Started on ${formattedStartCycleDate}`;
  }

  if (!isDailyLengthBudget) {
    return `${oneTimeCurrentCycleText} ${linkWord} ${formattedStartCycleDate} - ${formattedEndCycleDate}${unavailableText}`;
  }

  return `${oneTimeCurrentCycleText} ${linkWord} ${formattedStartCycleDate}`;
}
